import PropTypes from 'prop-types';
import { useEffect } from 'react';

const { LP, $ } = window;

const FacetText = ({ facet, context }) => {
  useEffect(() => {
    $('.star-rating').tooltip();
  }, []);

  const handleClick = () => {
    return context.executeAction(LP.module('Searches').SearchActions.toggleFacet, {
      facet
    });
  };

  const starClass = (i) => {
    return `fa fa-lg text-action ${i <= facet.title ? 'fa-solid' : 'fa-regular'} fa-star`;
  };

  return (
    <li
      className={`lp-filter-item ${facet.active ? 'active' : ''}`}
      onClick={handleClick}
    >
      <span className="facet-text">
        <span
          className="star-rating"
          title="Our credentialed teachers reviewed and rated this resource based on these rigorous rubrics."
          data-toggle="tooltip"
          data-placement="top"
        >
          <i className={starClass(1)} />
          <i className={starClass(2)} />
          <i className={starClass(3)} />
          <i className={starClass(4)} />
          <i className={starClass(5)} />
        </span>
        {facet.title < 5 && <span className="ml5">&amp; Up</span>}
        <span className="text-muted ml5">({facet.formattedCount()})</span>
      </span>
    </li>
  );
};

FacetText.propTypes = {
  facet: PropTypes.object,
  context: PropTypes.object
};

export default FacetText;
